var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg68(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "33px",
    viewBox: "0 0 32 33",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6731 31C15.5769 31 15.4808 31 15.3846 30.9028L0.192308 16.7147C0.0961538 16.6176 0 16.5204 0 16.326C0 16.2288 0 16.0345 0.0961538 15.9373L13.8462 0.194357C13.9423 0.0971787 14.0385 0 14.2308 0C14.3269 0 14.5192 0 14.6154 0.0971787L29.8077 14.2853C29.9038 14.3824 30 14.4796 30 14.674C30 14.7712 30 14.9655 29.9038 15.0627L16.1538 30.8056C15.9615 30.9028 15.7692 31 15.6731 31Z",
    transform: "translate(0.75 0.75)",
    id: "Path",
    fill: "none",
    stroke: "#0E0E0E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg68);
export default __webpack_public_path__ + "static/media/68.ba506c9de71cfe58e33c2607136c62d5.svg";
export { ForwardRef as ReactComponent };